import React from "react";
// styles
import "./Searcbar.scss";
// assets
import icon__search from "../../assets/icons/icon-search.svg";
import { useFavoriteContext } from "../../context/providers/FavoriteContext";
import { useLessonContext } from "../../context/providers/LessonContext";

export default function Searchbar({ searchFavorite, searchTips, searchLesson, searchPronunciation }) {
	const text = React.useRef("");
	const { filterFavorite, clearFilter } = useFavoriteContext();
	const { filterLessons, filterTips, filterPronunciations } = useLessonContext();
	const onChange = (e) => {
		if (searchFavorite) {
			if (text.current.value !== "") {
				filterFavorite(e.target.value);
			} else {
				clearFilter();
			}
		}
		if (searchTips) {
			filterTips(e.target.value);
		}
		if (searchLesson) {
			filterLessons(e.target.value);
		}
		if (searchPronunciation) {
			filterPronunciations(e.target.value);
		}
	};

	return (
		<form className="searchbar position-relative mt-3" onSubmit={(e) => e.preventDefault()}>
			<input
				type="search"
				className="input input--primary input--with_icon searchbar__input"
				placeholder="Search lessons…"
				name="lesson"
				onChange={onChange}
				ref={text}
			/>
			<button type="submit" className="searchbar__button">
				<img src={icon__search} alt="search" />
			</button>
		</form>
	);
}
